import { FC, useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import styles from "./Hash.module.scss";
import LockSVG from "svg/icons/LockSVG";
import Arrow from "svg/icons/Arrow";
import useUrlData from "store/DataStore";

interface HashProps {}

const Hash: FC<HashProps> = () => {
  const allData = useUrlData((state) => state.data);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const arrowRef = useRef<HTMLDivElement>(null);

  const displayShortHash = (hash: any) => {
    return hash.substring(0, 7) + "..." + hash.substring(hash.length - 4);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(allData.payment_id);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const toggleDropdown = () => {
    if (!isDropdownOpen && arrowRef.current) {
      const rect = arrowRef.current.getBoundingClientRect();
      setDropdownPosition({
        top: rect.bottom + 8,
        left: rect.left
      });
    }
    setIsDropdownOpen(!isDropdownOpen);
  };

  useEffect(() => {
    if (isDropdownOpen) {
      const handleResize = () => {
        if (arrowRef.current) {
          const rect = arrowRef.current.getBoundingClientRect();
          setDropdownPosition({
            top: rect.bottom + 8,
            left: rect.left
          });
        }
      };
      window.addEventListener('resize', handleResize);
      window.addEventListener('scroll', handleResize);
      return () => {
        window.removeEventListener('resize', handleResize);
        window.removeEventListener('scroll', handleResize);
      };
    }
  }, [isDropdownOpen]);

  return (
    <>
      <div className={styles.hashCont}>
        <div ref={arrowRef} className={styles.arrow} onClick={toggleDropdown}>
          <Arrow stroke="black"/>
        </div>
        <span className={styles.hash}>{displayShortHash(allData.payment_id)}</span>
        <LockSVG width="16" height="16" />
      </div>
      
      {isDropdownOpen && createPortal(
        <>
          <div className={styles.overlay} onClick={toggleDropdown} />
          <div 
            className={styles.dropdown}
            style={{
              top: `${dropdownPosition.top}px`,
              left: `${dropdownPosition.left}px`
            }}
          >
            <div className={styles.dropdownContent}>
              <div className={styles.fullId}>
                <span className={styles.idText}>{allData.payment_id}</span>
              </div>
              <button className={styles.copyButton} onClick={handleCopy}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 3.13281H4C2.89543 3.13281 2 4.02824 2 5.13281V12.1328C2 13.2374 2.89543 14.1328 4 14.1328H14C15.1046 14.1328 16 13.2374 16 12.1328V5.13281C16 4.02824 15.1046 3.13281 14 3.13281Z" stroke={copied ? "#1A1825" : "#BFBCC9"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                  <path d="M19 8C20.1 8 21 8.9 21 10V17C21 18.1 20.1 19 19 19H9C7.9 19 7 18.1 7 17V16.6328" stroke={copied ? "#1A1825" : "#BFBCC9"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                </svg>
              </button>
            </div>
          </div>
        </>,
        document.body
      )}
    </>
  );
};

export default Hash;
